import { render, staticRenderFns } from "./BibModal.vue?vue&type=template&id=aef9ecbc&"
import script from "./BibModal.vue?vue&type=script&lang=js&"
export * from "./BibModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node/your.borobudurmarathon.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aef9ecbc')) {
      api.createRecord('aef9ecbc', component.options)
    } else {
      api.reload('aef9ecbc', component.options)
    }
    module.hot.accept("./BibModal.vue?vue&type=template&id=aef9ecbc&", function () {
      api.rerender('aef9ecbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BibModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/BibModal.vue
// module id = 637
// module chunks = 0